import styled from '@emotion/styled';
import DraggableStepCard from '../../DraggableStepCard';

import { getDescriptionValue } from 'pages/AutomationEngine/Engine/Steps/type/variable/getDescriptionValue';

const Container = styled.span`
  font-size: 1.4em;
  * {
    font-size: 1em;
  }
`;

export const content = ({ step }) => (
  <Container dangerouslySetInnerHTML={{ __html: step.description }} />
);

export const getDescription = ({ step: { details }, t }) => {
  const { descriptionValue, descriptionPlural } = getDescriptionValue({
    details,
    t,
  });

  return t(`%{variableName}% = %{descriptionValue}%%{descriptionPlural}%`, {
    interpolation: { prefix: '%{', suffix: '}%' },
    variableName: details.chosenVariable?.label,
    descriptionValue,
    descriptionPlural,
  });
};
export default function UpdateVariableCard({ step, ...others }) {
  return <DraggableStepCard {...others}>{content({ step })}</DraggableStepCard>;
}
